/**
 * Active vs. terminal classification for the My Rides screen. "Active" items
 * are ongoing or upcoming and stay on the main screen; everything else moves
 * to the archive folder so the driver can focus on what's live.
 */

/** Ride is upcoming or in progress. */
const ACTIVE_RIDE_STATUSES = ['published', 'full', 'departed'] as const;
/** Booking still needs attention (awaiting decision or confirmed/upcoming). */
const ACTIVE_BOOKING_STATUSES = ['pending', 'approved'] as const;

export function isRideActive(status: string): boolean {
  return (ACTIVE_RIDE_STATUSES as readonly string[]).includes(status);
}

export function isBookingActive(status: string): boolean {
  return (ACTIVE_BOOKING_STATUSES as readonly string[]).includes(status);
}
